import { useContext, useEffect, useMemo, useState } from "react"
import { formJson } from "../../../utils/formJson";
import { useCommanKit } from "./useCommanKit";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";

export const useESICDeclaration = ({ data, label }) => {
    const { showSuccess, showError } = useContext(ToastContext)
    const { fieldData, getDataKey } = formJson?.[label];
    const { getEmployeeDetails } = useCommanKit({ data });
    const [formValues, setFormValues] = useState({});
    const [showPopup, setShowPopup] = useState({
        visibel: false,
        section: "",
        row: ""
    })
    const [familyData, setFamilyData] = useState([]);


    useEffect(() => {
        callAPI("user_family_details")
        callAPI(getDataKey)
    }, [data?.employee]);

    const callAPI = (key) => {
        data?.employee?.user_code && getEmployeeDetails(key, data?.employee?.user_code).then((res) => {
            Object.entries(fieldData).forEach(([sectionName, sectionObj]) => {
                if (key === "user_family_details") {
                    const data = res?.user_family_details?.map(item => ({
                        label: item.member_name,
                        value: item?.family_id
                    }));
                    setFamilyData(data)

                } else {
                    setFormValues((prev) => {
                        const data = res?.[sectionObj.key] || [];
                        return {
                            ...prev,
                            esic_option_1: res?.esic_option_1?.[0],
                            esic_option_2: res?.esic_option_2?.[0],
                            employee_esic_identity_card_details: res?.employee_esic_identity_card_details?.[0],
                            [sectionName]: data,
                        };

                    });
                }

            })
        })
    }

    const handleDelete = async (section, row) => {
        try {
            const payload = {
                "attribute_item_delete_key": fieldData[section]["deleteKey"],
                "education_id": row?.education_id || 0,
                "family_id": 0,
                "language_id": row?.language_id || 0,
                "reference_id": row?.reference_id || 0,
                "experience_id": row?.experience_id || 0,
                "insurance_nomination_id": row?.insurance_nomination_id || 0,
                "efp_nomination_id": row?.efp_nomination_id || 0,
                "eps_nomination_id": row?.eps_nomination_id || 0,
                "esic_nominee_id": row?.esic_id || 0,
                "esic_witness_id": row?.esic_id || 0,
                "esic_family_insured_id": row?.esic_family_insured_id || 0,
                "esic_nominee_details_id": row?.esic_id || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETEEMPLOYEEDETAILSREMOVE"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                setShowPopup({ visibel: false, section: "", row: "" })
                callAPI(getDataKey)
            } else {
                showError("error", res?.body?.errorMessage);
            }
        } catch (error) {
            console.error(error)
        }
    }


    const insuredPersonFields = [
        { key: "esic_family_insured_id", label: "Insurance No.", type: "text" },
        { key: "user_display_name", label: "Name in block letters", type: "text" },
        { key: "user_display_name", label: "Father's/Husband's Name", type: "text" },
        { key: "birth_date", label: "Date of Birth", type: "date" },
        { key: "marital_status", label: "Marital Status", type: "text" },
        { key: "gender", label: "Sex", type: "text" },
        { key: "present_contact_address", label: "Present Address", type: "text" },
        { key: "permanent_contact_address", label: "Permanent Address", type: "text" },
    ];

    const employerFields = [
        { key: "employee_id", label: "Employer's Code No.", type: "text" },
        { key: "confirmation_date", label: "Date of Appointment", type: "date" },
        { key: "company_address", label: "Address of the Employer", type: "text" },
    ];
    const esicIdentityField = [
        { key: "user_display_name", label: "Name", type: "text" },
        { key: "esic_family_insured_id", label: "Ins. No", type: "text" },
        { key: "branch", label: "Branch Office", type: "text" },
        { key: "confirmation_date", label: "Date of Appointment", type: "date" },
        { key: "", label: "Dispensary", type: "text" },
        { key: "", label: "Employer's Code No. & Address", type: "text" },
    ]


    return useMemo(() => ({
        fieldData, formValues, showPopup, setShowPopup, callAPI, familyData, handleDelete, insuredPersonFields, employerFields, esicIdentityField
    }), [fieldData, formValues, showPopup, setShowPopup, callAPI, familyData, handleDelete, insuredPersonFields, employerFields, esicIdentityField])
}